import { gql } from "@apollo/client";
import type { Section, Announcement, Dues, PdrStatus } from "./types";
import { CURRENT_MEMBER_FRAGMENT, CurrentMember } from "../fragments";

interface PdrRequirement {
  label: string;
  totalRequirement: number;
  cycleRequirement: number;
  earned: number;
  deficit: number;
  recoveryThreshold: number;
  recoveryRemaining: number;
}
export interface PdrRequirements {
  cycleCode: string;
  cycleEndsOn: string;
  cycleStartsOn: string;
  requirementsEffectiveDate: string;
  cohort: string;
  status: string;
  requirements: PdrRequirement[];
}
export interface ProfileQuery {
  me: {
    id?: string;
    photo?: string;
    displayName: string;
    firstName?: string;
    lastName?: string;
    memberClass?: string;
    certifiedProfessional?: boolean;
    specializedProfessional?: boolean;
    masterProfessional?: boolean;
    section: Section;
    dues?: Dues;
    pdrStatus?: PdrStatus;
  };
  announcements: Announcement[];
  currentPerson: {
    id: string;
    pdrRequirements: PdrRequirements;
  };
}

export interface EnrollmentQuery {
  currentMember: CurrentMember;
}

export const MEMBER_PROFILE_QUERY = gql`
  query MemberProfileQuery {
    me {
      id
      displayName
      photo
      section {
        id
        name
      }
    }
  }
`;

export const PDR_QUERY = gql`
  query PdrQuery {
    me {
      id
      pdrStatus: msrStatus {
        cycle {
          endDate
        }
        credits {
          label
          earned
          required
          recovery
          totalDeficit
        }
      }
    }
  }
`;
export const GET_PDR_REQUIREMENTS_QUERY = gql`
  query getPdrRequirements {
    currentPerson {
      id
      pdrRequirements {
        cycleCode
        cycleEndsOn
        cycleStartsOn
        requirementsEffectiveDate
        cohort
        status
        requirements {
          label
          totalRequirement
          cycleRequirement
          earned
          deficit
          recoveryThreshold
          recoveryRemaining
        }
      }
    }
  }
`;

export const ANNOUNCEMENT_QUERY = gql`
  query AnnouncementQuery {
    announcements(group: "MB", limit: 10) {
      title
      message
      label
      link
      date
    }
  }
`;

export const ENROLLMENT_QUERY = gql`
  query EnrollmentQuery {
    currentMember {
      ...CurrentMemberFragment
    }
  }
  ${CURRENT_MEMBER_FRAGMENT}
`;
